/** @file pointerToken: a key escaped for a JSON pointer (`~` → `~0`, `/` → `~1`, RFC 6901). */

/** `key` as one JSON pointer token, e.g. a slot key `head/0/1` → `head~10~11`. */
export function pointerToken(key: string): string {
  return key.replace(/~/g, '~0').replace(/\//g, '~1');
}
